import { Button, Dialog, DialogActions, DialogTitle, Slide } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import Context from '../../../context'

const Transition = React.forwardRef((props, ref) => {
  /* eslint react/jsx-props-no-spreading:0 */
  return <Slide direction="up" ref={ref} {...props} />
})

function DeleteDialog({ changeSituation }) {
  const { openDialog, setOpenDialog, imageToDelete } = useContext(Context)

  const handleClose = () => {
    setOpenDialog(false)
  }

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">Confirmar Remoção da Imagem?</DialogTitle>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            changeSituation(imageToDelete, 2)
            setOpenDialog(false)
          }}
          color="secondary"
        >
          Remover
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeleteDialog.propTypes = {
  changeSituation: PropTypes.func.isRequired
}

export default DeleteDialog
